import styled from 'styled-components';

export const FooterCarlineStyle = styled.div`
	.headline__main,
	.headline__sub {
		font-size: 16px;
		line-height: 24px;
		display: flex;
		flex-direction: row;
		width: auto;

		sup {
			font-size: 10px !important;
		}
	}

	.headline__sub {
		display: inline;
	}
`;
